import { useEffect, useState } from 'react';
import { Desktop, Mobile } from '../../App';
import flipMeGetConnected from '../../assets/images/backoffice/flipMe/flipMeGetConnected.png';
import flipMeGetConnectedEarnings from '../../assets/images/backoffice/flipMe/flipMeGetConnectedEarnings.png';
import flipMeGetConnectedMobile from '../../assets/images/backoffice/flipMe/flipMeGetConnectedMobile.png';
import flipMeGetConnectedRestart from '../../assets/images/backoffice/flipMe/flipMeGetConnectedRestart.png';
import flipMeGetConnectedEarningsRestart from '../../assets/images/backoffice/flipMe/flipMeGetConnectedEarningsRestart.png';
import flipMeGetConnectedMobileRestart from '../../assets/images/backoffice/flipMe/flipMeGetConnectedMobileRestart.png';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { FlipMeWallet } from './FlipMeWallet';
import { flipMeGetInfo } from './FlipMeWallet.actions';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../app/hooks';
import { settingsInit } from '../Settings/Settings.actions';
import { flipMeTitle } from '../../helpers/helperFunctions';

interface FlipMeBannerProps {
  isEarnings?: boolean;
  isOpen: boolean;
  setIsOpen: any;
  dashboard?: any;
}

export enum ConnectWallet {
  FIRST_STEP = 1,
  SECOND_STEP,
  THIRD_STEP,
  TWO_FA_REQUIRED
}

export enum ConnectWalletStatus {
  START,
  RESTART,
  CONNECTED
}

export const FlipMeBanner = ({
  isEarnings,
  isOpen,
  setIsOpen,
  dashboard
}: FlipMeBannerProps) => {
  const [step, setStep] = useState<number>(ConnectWallet.FIRST_STEP);

  const dispatch = useDispatch();
  const { flipMeStatus } = useAppSelector((state) => state.wallets);

  const showFlipMeBanners = (flipMeStatus: number) => {
    switch (flipMeStatus) {
      case ConnectWalletStatus.START:
        return (
          <>
            <Desktop>
              <img
                src={
                  isEarnings ? flipMeGetConnectedEarnings : flipMeGetConnected
                }
                alt='flipMeBanner'
                style={{ width: '100%', cursor: 'pointer' }}
                onClick={() => {
                  setIsOpen(!isOpen);
                  setStep(ConnectWallet.FIRST_STEP);
                }}
              />
            </Desktop>
            <Mobile>
              <img
                src={flipMeGetConnectedMobile}
                alt='flipMeMobile'
                style={{ width: '100%', cursor: 'pointer' }}
                onClick={() => {
                  setIsOpen(!isOpen);
                  setStep(ConnectWallet.FIRST_STEP);
                }}
              />
            </Mobile>
          </>
        );

      case ConnectWalletStatus.RESTART:
        return (
          <>
            <Desktop>
              <img
                src={
                  isEarnings
                    ? flipMeGetConnectedEarningsRestart
                    : flipMeGetConnectedRestart
                }
                alt='flipMeBanner'
                style={{ width: '100%', cursor: 'pointer' }}
                onClick={() => {
                  setIsOpen(!isOpen);
                  setStep(ConnectWallet.FIRST_STEP);
                }}
              />
            </Desktop>
            <Mobile>
              <img
                src={flipMeGetConnectedMobileRestart}
                alt='flipMeMobile'
                style={{ width: '100%', cursor: 'pointer' }}
                onClick={() => {
                  setIsOpen(!isOpen);
                  setStep(ConnectWallet.FIRST_STEP);
                }}
              />
            </Mobile>
          </>
        );

      case ConnectWalletStatus.CONNECTED:
        return <></>;

      default:
        break;
    }
  };

  useEffect(() => {
    dispatch(flipMeGetInfo());
  }, [dispatch]);

  return (
    <>
      {showFlipMeBanners(flipMeStatus)}

      <SidebarModal
        isOpen={isOpen}
        setOpen={() => {
          setIsOpen(!isOpen);
          step === ConnectWallet.SECOND_STEP && dispatch(flipMeGetInfo());
        }}
        title={flipMeTitle(step)}
        sidebarWidth={'520px'}>
        <FlipMeWallet setStep={setStep} step={step} setIsOpen={setIsOpen} />
      </SidebarModal>
    </>
  );
};
